import Link from 'next/link';
import styled from 'styled-components';

export default function InfoSection() {
  return (
    <Container>
      <OuterWrapper>
        <InnerWrapper>
          <TitleWrapper>
            <FakeTitle>청소하지마세요 청연하세요</FakeTitle>
            <TitleDesktop>{TitleDesktopSvg}</TitleDesktop>
            <TitleTablet>{TitleTabletSvg}</TitleTablet>
            <TitleMobile>{TitleMobileSvg}</TitleMobile>
          </TitleWrapper>
          <ItemList>
            <Item>
              <ItemTitle>매뉴얼 청소</ItemTitle>
              <ItemDescription>
                누적 집청소 300만 건의 표준화된 청소 메뉴얼로 <Br /> 우리집 청소를 진행합니다.
              </ItemDescription>
            </Item>
            <Item>
              <ItemTitle>청소연구소 매니저</ItemTitle>
              <ItemDescription>
                5단계의 집청소 교육을 수료한 매니저가 <Br /> 방문해 체계적인 청소 서비스를 제공합니다.
              </ItemDescription>
            </Item>
          </ItemList>
        </InnerWrapper>
      </OuterWrapper>
      <RecruitContainer>
        <RecruitWrapper>
          <RecuritText>
            <RecruitHighlight>늘 - 하던 집안일로 용돈 벌기!</RecruitHighlight>
            <RecruitNormal> 청소연구소 매니저 상시 모집</RecruitNormal>
          </RecuritText>
          <Link href="/manager_apply" passHref>
            <RecuritLink target="_blank">
              매니저 시작하기
              <RightArrowIcon>
                <RightArrowDesktop>{RightArrowDesktopSvg}</RightArrowDesktop>
                <RightArrowTablet>{RightArrowTabletSvg}</RightArrowTablet>
              </RightArrowIcon>
            </RecuritLink>
          </Link>
        </RecruitWrapper>
      </RecruitContainer>
    </Container>
  );
}

const Container = styled.section`
  width: 100%;
`;

const OuterWrapper = styled.div`
  position: relative;
  padding: 0 24px;
  padding-top: 115px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    padding-top: 78px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    padding-top: 86px;
  }
`;

const InnerWrapper = styled.div`
  position: relative;
  margin: 0 auto;
  max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.desktop};

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.tablet};
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    /* max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.mobile}; */
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 140px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    margin-bottom: 80px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    margin-bottom: 70px;
  }
`;

const FakeTitle = styled.h1`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  margin: -1px;
  clip: rect(0, 0, 0, 0);
  text-indent: -5000px;
`;

const TitleDesktop = styled.div`
  display: block;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    display: none;
  }
`;

const TitleTablet = styled.div`
  display: none;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    display: block;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    display: none;
  }
`;

const TitleMobile = styled.div`
  display: none;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    display: block;
  }
`;

const ItemList = styled.ul`
  list-style: none;
  padding-bottom: 70px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    padding-bottom: 15px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    padding-bottom: 36px;
  }
`;

const Item = styled.dl`
  display: flex;
  flex-direction: row;
  border-top: 1px solid #e5e5e5;
  padding: 20px 0 60px 0;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    padding: 20px 0 45px 0;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    padding: 16px 0 74px 0;
    flex-direction: column;
  }
`;

const ItemTitle = styled.dt`
  width: 50%;
  font-weight: 600;
  font-size: 24px;
  line-height: 140%;
  color: #227886;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 20px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    font-size: 19px;
    margin-bottom: 24px;
    width: 100%;
  }
`;

const ItemDescription = styled.dd`
  width: 50%;
  font-weight: 300;
  font-size: 20px;
  line-height: 140%;
  color: rgba(0, 0, 0, 0.6);

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 17px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    font-size: 16px;
    width: auto;
    padding-right: 30px;
    font-weight: 400;
  }
`;

const RecruitContainer = styled.div`
  background: #e1f5f8;
  padding: 0 24px;
`;

const RecruitWrapper = styled.div`
  position: relative;
  margin: 0 auto;
  width: 100%;
  display: flex;
  justify-content: space-between;

  max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.desktop};

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.tablet};
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    /* max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.mobile}; */
  }
`;

const Br = styled.br`
  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    display: none;
  }
`;

const RecuritText = styled.p`
  font-weight: 400;
  line-height: 140%;
  font-size: 19px;
  padding: 26px 0;
  margin-right: 16px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 17px;
    padding: 22px 0;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    font-size: 14px;
  }
`;

const RecruitHighlight = styled.span`
  font-weight: 600;
`;

const RecruitNormal = styled.span`
  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    display: none;
  }
`;

const RecuritLink = styled.a`
  color: #00bed6;
  font-size: 17px;
  font-weight: 500;
  line-height: 140%;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 17px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    font-size: 14px;
  }
`;

const RightArrowIcon = styled.div`
  margin-left: 12px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    margin-left: 7px;
  }
`;

const RightArrowDesktop = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    display: none;
  }
`;

const RightArrowTablet = styled.div`
  justify-content: center;
  align-items: center;
  display: none;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    display: flex;
  }
`;

const RightArrowSvg = (
  <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.06168 1L8 7.96927L1 15.0005"
      stroke="#00BED6"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const TitleDesktopSvg = (
  <svg width="506" height="45" viewBox="0 0 506 45" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.298 5.214V0.843999H6.142V5.214H19.298ZM30.384 35.804C30.384 38.748 27.808 40.588 23.99 40.588C20.31 40.588 17.688 38.748 17.688 35.804C17.688 32.86 20.31 31.02 23.99 31.02C27.808 31.02 30.384 32.86 30.384 35.804ZM36.088 26.144V0.614H30.982V13.862H23.714V18.14H30.982V26.144H36.088ZM9.96 12.206C9.868 13.31 9.638 14.276 9.224 15.15C7.66 18.692 4.118 20.808 0.162 22.326L2.554 26.374C7.108 25.04 11.432 21.36 12.858 18.048C14.33 21.314 18.976 24.304 23.024 25.546L25.232 21.406C21.138 20.302 17.734 18.14 16.354 14.874C16.032 14.092 15.802 13.172 15.71 12.206H24.036V7.882H1.358V12.206H9.96ZM35.536 35.804C35.536 30.514 30.752 26.696 23.99 26.696C17.366 26.696 12.536 30.514 12.536 35.804C12.536 41.186 17.366 44.958 23.99 44.958C30.752 44.958 35.536 41.186 35.536 35.804ZM79.9224 34.976V30.56H63.0864V21.636H58.0724V30.56H41.1904V34.976H79.9224ZM57.6124 1.81V4.34C57.6124 11.7 51.3104 16.944 44.0424 18.784L46.4344 23.2C52.8744 21.084 58.3944 17.266 60.5564 12.252C62.9484 17.22 67.9624 21.13 74.7244 23.154L77.0704 18.738C69.8944 16.76 63.5004 11.746 63.5004 4.34V1.81H57.6124ZM100.343 23.154C100.343 25.73 98.0888 27.524 95.3748 27.524C92.6608 27.524 90.4988 25.73 90.4988 23.154C90.4988 20.532 92.6608 18.784 95.3748 18.784C98.0888 18.784 100.343 20.532 100.343 23.154ZM105.219 23.154C105.219 18.048 100.665 14.69 95.3748 14.69C90.2688 14.69 85.4848 18.048 85.4848 23.154C85.4848 28.49 90.2688 31.756 95.3748 31.756C100.665 31.756 105.219 28.49 105.219 23.154ZM122.883 19.75V15.38H115.937V0.751998H110.877V39.07H115.937V19.75H122.883ZM107.059 12.712V8.434H82.5868V12.712H107.059ZM100.941 5.858V1.488H89.2108V5.858H100.941ZM154.711 39.07H159.817V0.751998H154.711V39.07ZM150.295 25.316C144.269 22.234 140.267 18.002 140.267 9.4V7.928H148.869V3.65H126.283V7.928H134.839V9.538C134.839 17.956 131.251 22.924 124.995 26.236L128.031 30.1C132.539 27.662 136.357 23.384 137.599 19.198C139.347 23.2 143.303 27.432 147.397 29.226L150.295 25.316ZM205.676 17.588V13.218H198.684V0.751998H193.532V39.07H198.684V17.588H205.676ZM181.618 23.062H171.728V7.56H181.618V23.062ZM186.724 27.34V3.144H166.622V27.34H186.724ZM227.844 24.718C223.198 21.912 219.656 16.898 219.656 7.882V2.546H214.412V7.882C214.412 17.082 210.916 22.28 205.994 25.73L209.122 29.502C212.756 27.248 215.93 22.694 217.034 18.646C218.276 22.418 221.496 26.604 224.624 28.49L227.844 24.718ZM238.562 39.116H243.622V0.751998H238.562V39.116ZM234.882 37.644V1.304H229.914V12.252H223.98V16.53H229.914V37.644H234.882ZM259.81 12.574C259.81 8.664 263.076 6.088 267.538 6.088C271.908 6.088 275.312 8.664 275.312 12.574C275.312 16.622 271.908 19.06 267.538 19.06C263.076 19.06 259.81 16.622 259.81 12.574ZM286.904 34.976V30.56H277.06V23.89H272V30.56H263.076V23.89H258.016V30.56H248.172V34.976H286.904ZM254.612 12.574C254.612 18.83 259.902 23.522 267.538 23.522C275.174 23.522 280.51 18.83 280.51 12.574C280.51 6.318 275.174 1.534 267.538 1.534C259.902 1.534 254.612 6.318 254.612 12.574ZM321.045 5.214V0.843999H307.889V5.214H321.045ZM332.131 35.804C332.131 38.748 329.555 40.588 325.737 40.588C322.057 40.588 319.435 38.748 319.435 35.804C319.435 32.86 322.057 31.02 325.737 31.02C329.555 31.02 332.131 32.86 332.131 35.804ZM337.835 26.144V0.614H332.729V13.862H325.461V18.14H332.729V26.144H337.835ZM311.707 12.206C311.615 13.31 311.385 14.276 310.971 15.15C309.407 18.692 305.865 20.808 301.909 22.326L304.301 26.374C308.855 25.04 313.179 21.36 314.605 18.048C316.077 21.314 320.723 24.304 324.771 25.546L326.979 21.406C322.885 20.302 319.481 18.14 318.101 14.874C317.779 14.092 317.549 13.172 317.457 12.206H325.783V7.882H303.105V12.206H311.707ZM337.283 35.804C337.283 30.514 332.499 26.696 325.737 26.696C319.113 26.696 314.283 30.514 314.283 35.804C314.283 41.186 319.113 44.958 325.737 44.958C332.499 44.958 337.283 41.186 337.283 35.804ZM374.08 6.502H363.316C361.292 4.386 358.348 3.052 354.898 3.052C348.366 3.052 343.674 7.698 343.674 13.632C343.674 19.704 348.366 24.212 354.898 24.212C358.578 24.212 361.706 22.786 363.684 20.394H374.08V30.284H379.232V0.705998H374.08V6.502ZM379.83 42.934V38.518H359.038V27.8H353.932V42.934H379.83ZM361.062 13.586C361.062 17.082 358.394 19.796 354.898 19.796C351.31 19.796 348.734 17.082 348.734 13.586C348.734 10.09 351.31 7.514 354.898 7.514C358.394 7.514 361.062 10.09 361.062 13.586ZM366.122 13.632C366.122 12.758 365.984 11.838 365.8 11.01H374.08V15.978H365.892C366.03 15.242 366.122 14.46 366.122 13.632ZM402.09 23.154C402.09 25.73 399.836 27.524 397.122 27.524C394.408 27.524 392.246 25.73 392.246 23.154C392.246 20.532 394.408 18.784 397.122 18.784C399.836 18.784 402.09 20.532 402.09 23.154ZM406.966 23.154C406.966 18.048 402.412 14.69 397.122 14.69C392.016 14.69 387.232 18.048 387.232 23.154C387.232 28.49 392.016 31.756 397.122 31.756C402.412 31.756 406.966 28.49 406.966 23.154ZM424.63 19.75V15.38H417.684V0.751998H412.624V39.07H417.684V19.75H424.63ZM408.806 12.712V8.434H384.334V12.712H408.806ZM402.688 5.858V1.488H390.958V5.858H402.688ZM446.799 24.718C442.153 21.912 438.611 16.898 438.611 7.882V2.546H433.367V7.882C433.367 17.082 429.871 22.28 424.949 25.73L428.077 29.502C431.711 27.248 434.885 22.694 435.989 18.646C437.231 22.418 440.451 26.604 443.579 28.49L446.799 24.718ZM457.517 39.116H462.577V0.751998H457.517V39.116ZM453.837 37.644V1.304H448.869V12.252H442.935V16.53H448.869V37.644H453.837ZM478.765 12.574C478.765 8.664 482.031 6.088 486.493 6.088C490.863 6.088 494.267 8.664 494.267 12.574C494.267 16.622 490.863 19.06 486.493 19.06C482.031 19.06 478.765 16.622 478.765 12.574ZM505.859 34.976V30.56H496.015V23.89H490.955V30.56H482.031V23.89H476.971V30.56H467.127V34.976H505.859ZM473.567 12.574C473.567 18.83 478.857 23.522 486.493 23.522C494.129 23.522 499.465 18.83 499.465 12.574C499.465 6.318 494.129 1.534 486.493 1.534C478.857 1.534 473.567 6.318 473.567 12.574Z"
      fill="black"
      fillOpacity="0.85"
    />
  </svg>
);

const TitleTabletSvg = (
  <svg width="304" height="27" viewBox="0 0 304 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.3838 3.343V0.778H3.66181V3.343H11.3838ZM17.8908 21.298C17.8908 23.026 16.3788 24.106 14.1378 24.106C11.9778 24.106 10.4388 23.026 10.4388 21.298C10.4388 19.57 11.9778 18.49 14.1378 18.49C16.3788 18.49 17.8908 19.57 17.8908 21.298ZM21.2388 15.628V0.643H18.2418V8.419H13.9758V10.93H18.2418V15.628H21.2388ZM5.90281 7.447C5.84881 8.095 5.71381 8.662 5.47081 9.175C4.55281 11.254 2.47381 12.496 0.151813 13.387L1.55581 15.763C4.22881 14.98 6.76681 12.82 7.60381 10.876C8.46781 12.793 11.1948 14.548 13.5708 15.277L14.8668 12.847C12.4638 12.199 10.4658 10.93 9.65581 9.013C9.46681 8.554 9.33181 8.014 9.27781 7.447H14.1648V4.909H0.853813V7.447H5.90281ZM20.9148 21.298C20.9148 18.193 18.1068 15.952 14.1378 15.952C10.2498 15.952 7.41481 18.193 7.41481 21.298C7.41481 24.457 10.2498 26.671 14.1378 26.671C18.1068 26.671 20.9148 24.457 20.9148 21.298ZM47.5077 20.812V18.22H37.6257V12.982H34.6827V18.22H24.7737V20.812H47.5077ZM34.4127 1.345V2.83C34.4127 7.15 30.7137 10.228 26.4477 11.308L27.8517 13.9C31.6317 12.658 34.8717 10.417 36.1407 7.474C37.5447 10.39 40.4877 12.685 44.4567 13.873L45.8337 11.281C41.6217 10.12 37.8687 7.177 37.8687 2.83V1.345H34.4127ZM60.0336 13.873C60.0336 15.385 58.7106 16.438 57.1176 16.438C55.5246 16.438 54.2556 15.385 54.2556 13.873C54.2556 12.334 55.5246 11.308 57.1176 11.308C58.7106 11.308 60.0336 12.334 60.0336 13.873ZM62.8956 13.873C62.8956 10.876 60.2226 8.905 57.1176 8.905C54.1206 8.905 51.3126 10.876 51.3126 13.873C51.3126 17.005 54.1206 18.922 57.1176 18.922C60.2226 18.922 62.8956 17.005 62.8956 13.873ZM73.2636 11.875V9.31H69.1866V0.723999H66.2166V23.215H69.1866V11.875H73.2636ZM63.9756 7.744V5.233H49.6116V7.744H63.9756ZM60.3846 3.721V1.156H53.4996V3.721H60.3846ZM92.4855 23.215H95.4825V0.723999H92.4855V23.215ZM89.8935 15.142C86.3565 13.333 84.0075 10.849 84.0075 5.8V4.936H89.0565V2.425H75.7995V4.936H80.8215V5.881C80.8215 10.822 78.7155 13.738 75.0435 15.682L76.8255 17.95C79.4715 16.519 81.7125 14.008 82.4415 11.551C83.4675 13.9 85.7895 16.384 88.1925 17.437L89.8935 15.142ZM122.939 10.606V8.041H118.835V0.723999H115.811V23.215H118.835V10.606H122.939ZM108.818 13.819H103.013V4.72H108.818V13.819ZM111.815 16.33V2.128H100.016V16.33H111.815ZM136.491 14.791C133.764 13.144 131.685 10.201 131.685 4.909V1.777H128.607V4.909C128.607 10.309 126.555 13.36 123.666 15.385L125.502 17.599C127.635 16.276 129.498 13.603 130.146 11.227C130.875 13.441 132.765 15.898 134.601 17.005L136.491 14.791ZM142.782 23.242H145.752V0.723999H142.782V23.242ZM140.622 22.378V1.048H137.706V7.474H134.223V9.985H137.706V22.378H140.622ZM155.794 7.663C155.794 5.368 157.711 3.856 160.33 3.856C162.895 3.856 164.893 5.368 164.893 7.663C164.893 10.039 162.895 11.47 160.33 11.47C157.711 11.47 155.794 10.039 155.794 7.663ZM171.697 20.812V18.22H165.919V14.305H162.949V18.22H157.711V14.305H154.741V18.22H148.963V20.812H171.697ZM152.743 7.663C152.743 11.335 155.848 14.089 160.33 14.089C164.812 14.089 167.944 11.335 167.944 7.663C167.944 3.991 164.812 1.183 160.33 1.183C155.848 1.183 152.743 3.991 152.743 7.663ZM192.816 3.343V0.778H185.094V3.343H192.816ZM199.323 21.298C199.323 23.026 197.811 24.106 195.57 24.106C193.41 24.106 191.871 23.026 191.871 21.298C191.871 19.57 193.41 18.49 195.57 18.49C197.811 18.49 199.323 19.57 199.323 21.298ZM202.671 15.628V0.643H199.674V8.419H195.408V10.93H199.674V15.628H202.671ZM187.335 7.447C187.281 8.095 187.146 8.662 186.903 9.175C185.985 11.254 183.906 12.496 181.584 13.387L182.988 15.763C185.661 14.98 188.199 12.82 189.036 10.876C189.9 12.793 192.627 14.548 195.003 15.277L196.299 12.847C193.896 12.199 191.898 10.93 191.088 9.013C190.899 8.554 190.764 8.014 190.71 7.447H195.597V4.909H182.286V7.447H187.335ZM202.347 21.298C202.347 18.193 199.539 15.952 195.57 15.952C191.682 15.952 188.847 18.193 188.847 21.298C188.847 24.457 191.682 26.671 195.57 26.671C199.539 26.671 202.347 24.457 202.347 21.298ZM224.485 4.099H218.167C216.979 2.857 215.251 2.074 213.226 2.074C209.392 2.074 206.638 4.801 206.638 8.284C206.638 11.848 209.392 14.494 213.226 14.494C215.386 14.494 217.222 13.657 218.383 12.253H224.485V18.058H227.509V0.696999H224.485V4.099ZM227.86 25.483V22.891H215.656V16.6H212.659V25.483H227.86ZM216.844 8.257C216.844 10.309 215.278 11.902 213.226 11.902C211.12 11.902 209.608 10.309 209.608 8.257C209.608 6.205 211.12 4.693 213.226 4.693C215.278 4.693 216.844 6.205 216.844 8.257ZM219.814 8.284C219.814 7.771 219.733 7.231 219.625 6.745H224.485V9.661H219.679C219.76 9.229 219.814 8.77 219.814 8.284ZM241.466 13.873C241.466 15.385 240.143 16.438 238.55 16.438C236.957 16.438 235.688 15.385 235.688 13.873C235.688 12.334 236.957 11.308 238.55 11.308C240.143 11.308 241.466 12.334 241.466 13.873ZM244.328 13.873C244.328 10.876 241.655 8.905 238.55 8.905C235.553 8.905 232.745 10.876 232.745 13.873C232.745 17.005 235.553 18.922 238.55 18.922C241.655 18.922 244.328 17.005 244.328 13.873ZM254.696 11.875V9.31H250.619V0.723999H247.649V23.215H250.619V11.875H254.696ZM245.408 7.744V5.233H231.044V7.744H245.408ZM241.817 3.721V1.156H234.932V3.721H241.817ZM268.248 14.791C265.521 13.144 263.442 10.201 263.442 4.909V1.777H260.364V4.909C260.364 10.309 258.312 13.36 255.423 15.385L257.259 17.599C259.392 16.276 261.255 13.603 261.903 11.227C262.632 13.441 264.522 15.898 266.358 17.005L268.248 14.791ZM274.539 23.242H277.509V0.723999H274.539V23.242ZM272.379 22.378V1.048H269.463V7.474H265.98V9.985H269.463V22.378H272.379ZM287.551 7.663C287.551 5.368 289.468 3.856 292.087 3.856C294.652 3.856 296.65 5.368 296.65 7.663C296.65 10.039 294.652 11.47 292.087 11.47C289.468 11.47 287.551 10.039 287.551 7.663ZM303.454 20.812V18.22H297.676V14.305H294.706V18.22H289.468V14.305H286.498V18.22H280.72V20.812H303.454ZM284.5 7.663C284.5 11.335 287.605 14.089 292.087 14.089C296.569 14.089 299.701 11.335 299.701 7.663C299.701 3.991 296.569 1.183 292.087 1.183C287.605 1.183 284.5 3.991 284.5 7.663Z"
      fill="black"
      fillOpacity="0.85"
    />
  </svg>
);

const TitleMobileSvg = (
  <svg width="169" height="65" viewBox="0 0 169 65" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.2304 3.586V0.804999H3.45438V3.586H11.2304ZM17.3864 21.19C17.3864 22.783 15.9014 23.782 13.9304 23.782C11.9054 23.782 10.5014 22.783 10.5014 21.19C10.5014 19.624 11.9054 18.625 13.9304 18.625C15.9014 18.625 17.3864 19.624 17.3864 21.19ZM20.8694 15.79V0.778H17.5754V8.365H13.7144V11.065H17.5754V15.79H20.8694ZM13.9304 7.69V4.909H0.727383V7.69H5.53338C5.12838 10.579 2.67138 12.361 0.0253829 13.171L1.51038 15.79C4.15638 14.98 6.61338 12.901 7.42338 11.065C8.26038 12.874 11.0144 14.737 13.2824 15.277L14.6864 12.604C11.8784 11.902 9.66438 10.444 9.28638 7.69H13.9304ZM20.6534 21.19C20.6534 18.085 17.8184 15.871 13.9304 15.871C10.0424 15.871 7.20738 18.085 7.20738 21.19C7.20738 24.403 10.0424 26.536 13.9304 26.536C17.8184 26.536 20.6534 24.403 20.6534 21.19ZM46.5843 20.812V18.058H36.9993V12.955H33.6783V18.058H24.0663V20.812H46.5843ZM33.4083 1.426V2.911C33.4083 7.285 29.7093 10.039 25.7133 11.119L27.1983 13.954C30.8973 12.82 33.9483 10.633 35.3253 7.69C36.7833 10.525 39.6723 12.712 43.4793 13.9L44.9643 11.092C41.0223 9.958 37.2423 7.285 37.2423 2.911V1.426H33.4083ZM58.4752 13.846C58.4752 15.223 57.2602 16.222 55.8562 16.222C54.3982 16.222 53.2102 15.223 53.2102 13.846C53.2102 12.388 54.3982 11.524 55.8562 11.524C57.2602 11.524 58.4752 12.388 58.4752 13.846ZM61.6342 13.846C61.6342 10.741 58.8802 8.878 55.8562 8.878C52.8322 8.878 50.0512 10.741 50.0512 13.846C50.0512 17.032 52.8322 18.895 55.8562 18.895C58.8802 18.895 61.6342 17.032 61.6342 13.846ZM71.8402 12.01V9.229H67.8712V0.831999H64.5232V23.107H67.8712V12.01H71.8402ZM62.6332 7.987V5.233H48.4042V7.987H62.6332ZM59.0692 3.964V1.21H52.2652V3.964H59.0692ZM90.3461 23.107H93.6131V0.831999H90.3461V23.107ZM88.1321 14.926C84.6761 13.225 82.3541 10.687 82.3541 5.692V5.206H87.2411V2.452H74.0651V5.206H78.8711V5.746C78.8711 10.66 76.8461 13.495 73.2551 15.412L75.1991 17.95C77.6831 16.519 79.8971 14.224 80.6531 11.767C81.5711 14.116 84.1091 16.357 86.2691 17.437L88.1321 14.926ZM120.516 10.714V7.96H116.493V0.831999H113.199V23.107H116.493V10.714H120.516ZM106.287 13.603H101.076V4.963H106.287V13.603ZM109.581 16.33V2.182H97.7819V16.33H109.581ZM133.649 14.575C131.084 13.063 129.032 10.201 129.032 4.801V1.831H125.684V4.801C125.684 10.228 123.794 13.09 120.905 15.169L122.903 17.599C124.874 16.357 126.818 13.765 127.385 11.605C127.979 13.603 130.031 16.087 131.597 17.005L133.649 14.575ZM139.643 23.134H142.883V0.831999H139.643V23.134ZM137.753 22.216V1.156H134.594V7.339H131.408V10.12H134.594V22.216H137.753ZM152.803 7.717C152.803 5.611 154.639 4.153 157.015 4.153C159.391 4.153 161.254 5.611 161.254 7.717C161.254 9.877 159.391 11.281 157.015 11.281C154.639 11.281 152.803 9.877 152.803 7.717ZM168.274 20.839V18.058H162.631V14.413H159.337V18.058H154.693V14.413H151.399V18.058H145.756V20.839H168.274ZM149.374 7.717C149.374 11.389 152.479 14.116 157.015 14.116C161.551 14.116 164.683 11.389 164.683 7.717C164.683 4.018 161.551 1.264 157.015 1.264C152.479 1.264 149.374 4.018 149.374 7.717ZM35.5683 41.586V38.805H27.7923V41.586H35.5683ZM41.7243 59.19C41.7243 60.783 40.2393 61.782 38.2683 61.782C36.2433 61.782 34.8393 60.783 34.8393 59.19C34.8393 57.624 36.2433 56.625 38.2683 56.625C40.2393 56.625 41.7243 57.624 41.7243 59.19ZM45.2073 53.79V38.778H41.9133V46.365H38.0523V49.065H41.9133V53.79H45.2073ZM38.2683 45.69V42.909H25.0653V45.69H29.8713C29.4663 48.579 27.0093 50.361 24.3633 51.171L25.8483 53.79C28.4943 52.98 30.9513 50.901 31.7613 49.065C32.5983 50.874 35.3523 52.737 37.6203 53.277L39.0243 50.604C36.2163 49.902 34.0023 48.444 33.6243 45.69H38.2683ZM44.9913 59.19C44.9913 56.085 42.1563 53.871 38.2683 53.871C34.3803 53.871 31.5453 56.085 31.5453 59.19C31.5453 62.403 34.3803 64.536 38.2683 64.536C42.1563 64.536 44.9913 62.403 44.9913 59.19ZM48.7822 46.365C48.7822 49.875 51.5092 52.548 55.3972 52.548C57.5572 52.548 59.3662 51.711 60.5542 50.334H66.2782V56.004H69.5452V38.832H66.2782V42.045H60.2572C59.0692 40.857 57.3682 40.128 55.3972 40.128C51.5092 40.128 48.7822 42.882 48.7822 46.365ZM69.8962 63.375V60.54H58.0702V54.519H54.7762V63.375H69.8962ZM52.0762 46.338C52.0762 44.394 53.4802 42.99 55.3972 42.99C57.2602 42.99 58.6912 44.394 58.6912 46.338C58.6912 48.282 57.2602 49.74 55.3972 49.74C53.4802 49.74 52.0762 48.282 52.0762 46.338ZM61.9042 47.499C61.9852 47.148 62.0122 46.77 62.0122 46.365C62.0122 45.879 61.9582 45.393 61.8502 44.907H66.2782V47.499H61.9042ZM82.8131 51.846C82.8131 53.223 81.5981 54.222 80.1941 54.222C78.7361 54.222 77.5481 53.223 77.5481 51.846C77.5481 50.388 78.7361 49.524 80.1941 49.524C81.5981 49.524 82.8131 50.388 82.8131 51.846ZM85.9721 51.846C85.9721 48.741 83.2181 46.878 80.1941 46.878C77.1701 46.878 74.3891 48.741 74.3891 51.846C74.3891 55.032 77.1701 56.895 80.1941 56.895C83.2181 56.895 85.9721 55.032 85.9721 51.846ZM96.1781 50.01V47.229H92.2091V38.832H88.8611V61.107H92.2091V50.01H96.1781ZM86.9711 45.987V43.233H72.7421V45.987H86.9711ZM83.4071 41.964V39.21H76.6031V41.964H83.4071ZM109.311 52.575C106.746 51.063 104.694 48.201 104.694 42.801V39.831H101.346V42.801C101.346 48.228 99.4559 51.09 96.5669 53.169L98.5649 55.599C100.536 54.357 102.48 51.765 103.047 49.605C103.641 51.603 105.693 54.087 107.259 55.005L109.311 52.575ZM115.305 61.134H118.545V38.832H115.305V61.134ZM113.415 60.216V39.156H110.256V45.339H107.07V48.12H110.256V60.216H113.415ZM128.465 45.717C128.465 43.611 130.301 42.153 132.677 42.153C135.053 42.153 136.916 43.611 136.916 45.717C136.916 47.877 135.053 49.281 132.677 49.281C130.301 49.281 128.465 47.877 128.465 45.717ZM143.936 58.839V56.058H138.293V52.413H134.999V56.058H130.355V52.413H127.061V56.058H121.418V58.839H143.936ZM125.036 45.717C125.036 49.389 128.141 52.116 132.677 52.116C137.213 52.116 140.345 49.389 140.345 45.717C140.345 42.018 137.213 39.264 132.677 39.264C128.141 39.264 125.036 42.018 125.036 45.717Z"
      fill="black"
      fillOpacity="0.85"
    />
  </svg>
);

const RightArrowDesktopSvg = (
  <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.06168 1L8 7.96927L1 15.0005"
      stroke="#00BED6"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const RightArrowTabletSvg = (
  <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.30968 1L6.26563 5.97787L1.26562 11"
      stroke="#00BED6"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
